const TEMP_TOKEN_KEY = 'temporaryPasswordChangeToken'
const TEMP_USER_KEY = 'temporaryPasswordChangeUser'
const TEMP_PASSWORD_KEY = 'temporaryPasswordChangePassword'

const sanitizeUserForSession = (user = {}) => ({
  id: user.id ?? null,
  email: user.email ?? null,
  name: user.name ?? null
})

export function saveTemporaryPasswordChangeSession(temporaryToken, user = null, temporaryPassword = null) {
  if (temporaryToken) {
    sessionStorage.setItem(TEMP_TOKEN_KEY, temporaryToken)
  }

  if (user) {
    sessionStorage.setItem(TEMP_USER_KEY, JSON.stringify(sanitizeUserForSession(user)))
  }

  if (temporaryPassword) {
    sessionStorage.setItem(TEMP_PASSWORD_KEY, temporaryPassword)
  }
}

export function getTemporaryPasswordChangeToken() {
  return sessionStorage.getItem(TEMP_TOKEN_KEY)
}

export function getTemporaryLoginPassword() {
  return sessionStorage.getItem(TEMP_PASSWORD_KEY)
}

export function isNewPasswordSameAsTemporary(newPassword = '') {
  const temporaryPassword = getTemporaryLoginPassword()

  if (!temporaryPassword || !newPassword) {
    return false
  }

  return newPassword === temporaryPassword
}

export function getTemporaryPasswordChangeUser() {
  const raw = sessionStorage.getItem(TEMP_USER_KEY)

  if (!raw) {
    return null
  }

  try {
    return JSON.parse(raw)
  } catch {
    sessionStorage.removeItem(TEMP_USER_KEY)
    return null
  }
}

export function hasTemporaryPasswordChangeSession() {
  return Boolean(getTemporaryPasswordChangeToken())
}

export function clearTemporaryPasswordChangeSession() {
  sessionStorage.removeItem(TEMP_TOKEN_KEY)
  sessionStorage.removeItem(TEMP_USER_KEY)
  sessionStorage.removeItem(TEMP_PASSWORD_KEY)
}

export const CHANGE_PASSWORD_PATH = '/change-password'
